module.exports = require('error-stack-parser')



// WEBPACK FOOTER //
// ../core/lib/error-stack-parser.js